import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

export const BeforeAfterSlider = ({ 
  beforeImage, 
  afterImage, 
  beforeLabel = "Avant", 
  afterLabel = "Après",
  className = "" 
}) => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);

  const handleMove = (e) => {
    if (!isDragging && e.type !== 'click') return;
    
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.type.includes('mouse') ? e.clientX : e.touches[0].clientX) - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setSliderPosition(percentage);
  };

  return (
    <div 
      data-testid="before-after-slider"
      className={cn(
        "relative w-full aspect-[4/3] rounded-xl overflow-hidden select-none",
        "shadow-[0_10px_30px_rgba(15,23,42,0.08)] hover:shadow-[0_16px_44px_rgba(15,23,42,0.12)]",
        "transition-shadow duration-200",
        className
      )}
      onMouseMove={handleMove}
      onTouchMove={handleMove}
      onMouseDown={() => setIsDragging(true)}
      onMouseUp={() => setIsDragging(false)}
      onMouseLeave={() => setIsDragging(false)}
      onTouchStart={() => setIsDragging(true)}
      onTouchEnd={() => setIsDragging(false)}
      onClick={handleMove}
    >
      {/* After Image (background) */}
      <div className="absolute inset-0">
        <img 
          src={afterImage} 
          alt={afterLabel}
          className="w-full h-full object-cover"
          draggable="false"
        />
        <div className="absolute top-4 right-4 bg-[#336DBF] text-white px-3 py-1.5 rounded-full text-sm font-medium">
          {afterLabel}
        </div>
      </div>

      {/* Before Image (overlay) */}
      <div 
        className="absolute inset-0 overflow-hidden"
        style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
      >
        <img 
          src={beforeImage} 
          alt={beforeLabel}
          className="w-full h-full object-cover"
          draggable="false"
        />
        <div className="absolute top-4 left-4 bg-[#2B2B2B] text-white px-3 py-1.5 rounded-full text-sm font-medium">
          {beforeLabel}
        </div>
      </div>

      {/* Slider Handle */}
      <div 
        className="absolute top-0 bottom-0 w-1 bg-white cursor-ew-resize z-10"
        style={{ left: `${sliderPosition}%`, transform: 'translateX(-50%)' }}
      >
        <motion.div 
          className="absolute top-1/2 left-1/2 w-12 h-12 -translate-x-1/2 -translate-y-1/2"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <div className="w-full h-full rounded-full bg-white shadow-lg flex items-center justify-center">
            <div className="flex gap-1">
              <div className="w-0.5 h-4 bg-[#336DBF] rounded-full" />
              <div className="w-0.5 h-4 bg-[#336DBF] rounded-full" />
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};